// 3rd Part
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { IconChevronLeft, IconChevronRight } from '@tabler/icons-react';

// Components
import { VisuallyHidden } from 'common/styles/oc-styled-components';

import {
  SlotPickerScrollButton,
  SlotPickerTime,
  SlotPickerTimesList,
} from 'pages/common/components/SlotPicker/styled-components';

// Other
import {
  getTimeFromStartTime,
  getDateForScreenReader,
} from '../../../helpers/appointment-slot-helpers';

import { NavigationRow } from './styled-components';

const MAX_SLOTS_PER_PAGE = 12;
const MAX_SLOTS_PER_ROW = 3;
export const SlotPickerTimeSlots = ({ dayIndex, handleSelect, slots }) => {
  const [index, setIndex] = useState(0);

  const handleScrollNext = () => {
    setIndex(index + MAX_SLOTS_PER_PAGE);
  };

  const handleScrollPrevious = () => {
    setIndex(index - MAX_SLOTS_PER_PAGE);
  };

  // Deduplicate slots with the same date and time
  const uniqueSlots = slots.filter(
    (item, itemIndex, array) =>
      itemIndex
      === array.findIndex(
        foundSlot =>
          item.date === foundSlot.date && item.time === foundSlot.time,
      ),
  );

  const showArrows = uniqueSlots.length > MAX_SLOTS_PER_PAGE;
  const slotsForDisplay = uniqueSlots.slice(index, index + MAX_SLOTS_PER_PAGE);

  if (!uniqueSlots?.length) {
    return <VisuallyHidden>No timeslots available</VisuallyHidden>;
  }

  return (
    <>
      <SlotPickerTimesList
        aria-live="polite"
        data-testid="instant-book-slot-column"
        maxSlotsPerRow={MAX_SLOTS_PER_ROW}
      >
        {slotsForDisplay.map((slot, i) => (
          <SlotPickerTime
            key={slot.id}
            onClick={() => handleSelect(slot, i, dayIndex)}
            aria-label={`${getTimeFromStartTime(
              slot.time,
              'h:mm A',
            )} ${getDateForScreenReader(slot.date)}`}
          >
            {/* Prevent screen reader from including button contents in aria-live change announcment */}
            <span aria-hidden>{getTimeFromStartTime(slot.time, 'h:mm a')}</span>
          </SlotPickerTime>
        ))}
      </SlotPickerTimesList>

      {showArrows 
        && (
          <NavigationRow>
            <SlotPickerScrollButton
              onClick={handleScrollPrevious}
              disabled={index <= 0}
              aria-label="Previous timeslots"
            >
              <IconChevronLeft /> Previous
            </SlotPickerScrollButton>

            <SlotPickerScrollButton
              onClick={handleScrollNext}
              disabled={index >= uniqueSlots.length - MAX_SLOTS_PER_PAGE}
              aria-label="Next timeslots"
            >
              Next <IconChevronRight />
            </SlotPickerScrollButton>
          </NavigationRow>
        )
      }
    </>
  );
};

SlotPickerTimeSlots.propTypes = {
  dayIndex: PropTypes.number,
  handleSelect: PropTypes.func,
  slots: PropTypes.array,
};
